import {
  ECustomRangeType,
  TAbsoluteTimeUnit,
  TRelativeTimeUnit, TSkipButtonTranslations,
} from '@/components/date-range-picker/date-range-picker.ts';

const timeUnits: Record<TRelativeTimeUnit | TAbsoluteTimeUnit, string> = {
  day: 'Data',
  days: 'Dzień | Dni',
  hours: 'Godzina | Godziny',
  isoWeek: 'Tydzień kalendarzowy | Tygodnie kalendarzowe',
  minutes: 'Minuta | Minuty',
  months: 'Miesiąc | Miesiące',
  quarters: 'Kwartał | Kwartały',
  weeks: 'Tydzień | Tygodnie',
  years: 'Rok | Lata',
};

const timeUnitsShort: Record<TRelativeTimeUnit | TAbsoluteTimeUnit, string> = {
  day: '',
  days: 'D',
  hours: 'H',
  isoWeek: 'CW',
  minutes: 'minimum',
  months: 'M',
  quarters: 'Q',
  weeks: 'w',
  years: 'y',
};

const header: Record<ECustomRangeType, string> = {
  [ECustomRangeType.ABSOLUTE]: 'Absolutny',
  [ECustomRangeType.CUSTOM]: 'Zwyczaj',
  [ECustomRangeType.RELATIVE]: 'Względny',
  [ECustomRangeType.BY_JOB]: 'Po jobie',
};

const skipButtonTranslations: TSkipButtonTranslations = {
  next: 'Przesuń {formattedDuration} do przodu, do {to}',
  previous: 'Przesuń {formattedDuration} wstecz, do {to}',
};

const skipButtonTranslationsByJob: TSkipButtonTranslations = {
  next: 'Przejdź do następnego joba',
  previous: 'Przejdź do poprzedniego joba',
};

const directions: Record<'past' | 'future', string> = {
  past: 'Ostatnie',
  future: 'Następne',
};

export default {
  header,
  jobLabel: 'Job',
  lastJobLabel: 'Ostatni job',
  useLastJob: 'Uzyj ostatniego joba',
  convertToCustom: 'Konwertuj na niestandardowy',
  custom: 'Zwyczaj',
  currentWeek: 'bieżący tydzień',
  previousWeek: 'w zeszłym tygodniu',
  nextWeek: 'przyszły tydzień',
  calendarWeek: 'CW',
  rangeInvalidHint: 'Wybrany okres jest dłuższy niż maksymalny dopuszczalny czas trwania {maxDuration} lub wybrane daty wykraczają poza dopuszczalny zakres {minDate} - {maxDate}.',
  rangeFrom: 'Z',
  rangeTo: 'Do',
  timeUnit: 'Jednostka czasu',
  all: 'Wszystko',
  timeUnits,
  timeUnitsShort,
  skipButtonTranslations,
  skipButtonTranslationsByJob,
  directions,
};
